// apps/web/src/routes/$lang/_layout/stays.confirmation.$reference.tsx
import { createFileRoute } from "@tanstack/react-router";
import { StayConfirmationPage } from "../../../features/stays/pages/stay-confirmation-page";

/**
 * The guest lands here from the payment provider's returnUrl, built in
 * PaymentMount: `${window.location.origin}/${lang}/stays/confirmation/${reference}`.
 * `reference` is the only input the page needs — everything else comes from
 * finalising (idempotently) or reading the booking by that reference. The
 * guest may arrive here twice (back button, re-opened email link); the page
 * handles that itself, not this route.
 */
export const Route = createFileRoute("/$lang/_layout/stays/confirmation/$reference")({
  component: StayConfirmationPage,
});
